import * as ActionCreators from './actionCreators';
import * as CommonActions from './commonActions';
import * as ErrorActions from './errorActions';
import { methodConstants } from '../constants/methodConstants';
import { appConstants } from '../constants/appConstants';
import * as Http from '../api/http';
import * as OrderActions from './ordersActions';
import * as BankActions from './bankAccountActions';
import { selectTransformedBanks, selectRedeemPrograms } from '../selectors/layouts';
import { translateArray } from './defaultActions';

let isActiveSegmentIndex = -1;

export const setActiveTab = (index) => (dispatch) => {
  if (index === 0) {
    dispatch(receivedJson());
  } else {
    dispatch(sentJson());
  }
  dispatch(ActionCreators.tabSelected(index));
};

export const geteProductTitle = (items, mainrows, actionRows, mainColumns, indexes, received) => (dispatch, getState) => {
  const currentState = getState();
  const tableDataReceived = {columns: mainColumns, rows: mainrows, actions: actionRows};
  const tableDataSent = {columns: mainColumns, rows: mainrows, actions: actionRows};
  const trans = currentState.translationsGreatwork.customerLabels;
  let flag = -1;
  dispatch(ActionCreators.displayLoader(true));
  indexes.forEach((index) => {
    let title = '';

    let eProductAPI = CommonActions.getFullApiUrl(methodConstants.GET_EPRODUCT_URL, currentState);
    eProductAPI = CommonActions.modifyString(eProductAPI, '{:eProductId}', items[index].eProductId);
    const item = items[index];
    const request = {
      'nocache': Date.now().toString()
    };
    Http.get(eProductAPI, currentState, request).then((resp) => {
      title = resp.title;
      if(title.length === 0){
        title = resp.name;
      }
      let details = title && item.award  ?  `${item.type}: ${title} (${item.award.title}) - ${item.programName}` : `${item.type}: ${title} - ${item.programName}`;
      if(item.type === appConstants.ECARD){
        details = title && item.award  ?  `${trans['ecard-label']}: ${title} (${item.award.title}) - ${item.programName}` : `${trans['ecard-label']}: ${title} - ${item.programName}`;
      }
      if(received){
        flag = flag+1;
        mainrows[index][appConstants.OVERVIEW_RECEIVED_ID.DETAILS] = details;
      }else{
        flag = flag+1;
        mainrows[index][appConstants.OVERVIEW_SENT_ID.DETAILS] = details;
      }
          
      if(flag === indexes.length-1){
        if(received){
          dispatch(ActionCreators.overviewHistoryReceived(tableDataReceived));
          dispatch(ActionCreators.isDisplayReceivedActions(false));
          dispatch(ActionCreators.displayLoader(false));
      
        }else{
          dispatch(ActionCreators.overviewHistorySent(tableDataSent));
          dispatch(ActionCreators.isDisplayReceivedActions(false));
          dispatch(ActionCreators.displayLoader(false));
        }
      }

    }).catch((err) => {
      dispatch(ErrorActions.displayError(err));
    });

  });
  
};

function isReward(item){
  let val = false;
  if(item && item.type ){
    if(item.type.toLowerCase() === 'reward'){
      val = true;
    }
  }
  return val;
}

function getAvatarData(state) {
  const avatarUrl = CommonActions.getFullApiUrl(methodConstants.GET_AVATAR_URL, state);
  return new Promise(((resolve, reject) => {
    Http.get(avatarUrl, state).then((res) => {
      resolve(res);
    })
      .catch((err) => {
        reject(err);
      });
  }));
}

function getreceivedData(state) {
  const request = {
    'size': 4,
    'pages': '0',
    'nocache': Date.now().toString()
  };
  const receivedUrl = CommonActions.getFullApiUrl(methodConstants.GET_RECEIVED, state);
  return new Promise(((resolve, reject) => {
    Http.get(receivedUrl, state, request).then((res) => {
      resolve(res);
    })
      .catch((err) => {
        reject(err);
      });
  }));
}

function getLayoutsData(state) {
  const layoutUrl = CommonActions.getFullApiUrl(methodConstants.GET_LAYOUT_URL, state);
  return new Promise(((resolve, reject) => {
    Http.get(layoutUrl, state).then((res) => {
      resolve(res);
    })
      .catch((err) => {
        reject(err);
      });
  }));
}


function getGreatworkData(state, stp) {
  let customerStp = appConstants.OCTANNER_STP;

  if(stp){
    customerStp = stp;
  }
  let translationsUrl = CommonActions.getFullApiUrl(methodConstants.GET_GREATWORK_TRANSLATIONS, state);
  translationsUrl = CommonActions.modifyString(translationsUrl, '{:stp}', customerStp);
  return new Promise(((resolve, reject) => {
    Http.get(translationsUrl, state).then((res) => {
      const obj = {
        customerLabels: translateArray(appConstants.CUSTOMER_LABELS, res)
      };
      resolve(obj);
      
    })
      .catch((err) => {
        reject(err);
      });
  }));
}


function getInitialConfiguration(state) {
  return Promise.all([getAvatarData(state), getLayoutsData(state) , getreceivedData(state)]);
}


export const receivedJson = () => (dispatch, getState) => {
  
  const currentState = getState();
  dispatch(ActionCreators.displayLoader(true));
  let customerSTP = '';
  

  getInitialConfiguration(currentState)
    .then(([avatarData, layoutData, receivedData]) => {
      if(CommonActions.isDefined(layoutData.theme.stp)){
        customerSTP = layoutData.theme.stp;
      }
      const redeemedPrograms = selectRedeemPrograms(layoutData);
      dispatch(ActionCreators.customerSTP(customerSTP));
      dispatch(ActionCreators.redeemPrograms(redeemedPrograms));
      const banks = selectTransformedBanks(layoutData);

      getGreatworkData(currentState, customerSTP).then((result) => {
        dispatch(ActionCreators.translationsGreatwork(result));
        dispatch(dispatchReceivedActions(avatarData, receivedData, banks, redeemedPrograms));
        dispatch(ActionCreators.displayLoader(false));
    
      }).catch((err) => {
        dispatch(ErrorActions.displayError(err));
      });


    })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
    });
  
  

};

export const dispatchReceivedActions = (avatarData, receivedData, banks, redeemedPrograms) => (dispatch) => {
  const receivedColumns = [
    appConstants.OVERVIEW_RECEIVED_ID.DATE, 
    appConstants.OVERVIEW_RECEIVED_ID.DETAILS, 
    appConstants.OVERVIEW_RECEIVED_ID.SENDER, 
    appConstants.OVERVIEW_RECEIVED_ID.ACTIONS];
  const receivedRows = [];
  const actionRows = [];
  const indexes = [];


  receivedData.collection = CommonActions.sortDateByDesc(receivedData.collection);
  receivedData.collection.forEach ((item, index) => {
    const row = {};
    const actionCheck = {};
    const actions = [];
    if (item['type']==='nomination') {
      actions.push(appConstants.PRINT_CERTIFICATE_TRANS);
      actions.push(appConstants.VIEW);
      actionCheck['nomineeId'] = item['id'];
    }
    if (item['type'] === 'ecard') {
      actions.push(appConstants.VIEW);
      actionCheck['nomineeId'] = -1;
    }


    actionCheck['catalogLink'] = '';

    //catalog link validation
    
    if(redeemedPrograms.length > 0){
      if(item['type'] === appConstants.ECARD 
        || item['type'] === appConstants.NOMINATION 
        || item['type'] === appConstants.RULES 
        || isReward(item)){
        redeemedPrograms.forEach((redeem)  => {
          if(redeem['programId'] === item['programId']){
            actions.push(appConstants.CATALOG);
            switch (item['type'].toLowerCase()) {
              case appConstants.NOMINATION:
                actionCheck['catalogLink'] = banks.length > 0 ? banks[0].link.replace('#/cart','') + '&h2s=1&nominee=' + item.id: '';
                break;
              case appConstants.ECARD || appConstants.REWARD:
                actionCheck['catalogLink'] = banks.length > 0 ? banks[0].link.replace('#/cart',''): '';
                break;
              default:
                actionCheck['catalogLink'] = '';
                break;
            }
          }
        });
      }
    }


    if (item['shareableOnFacebook']) {
      actions.push(appConstants.SHARE_ON_FACEBOOK);
    }
    actionCheck['programId'] = item['programId'];
    actionCheck['id'] = item['id'];
    actionCheck['displayContainer'] = false;
    actionCheck['action'] = actions;
    actionCheck['uniqueId'] = 1000 + index;
    actionCheck['detailsHref'] = item['detailsHref'];

    //values for eCardactivity values:
    actionCheck['corporateValue'] = item.corporateValue;
    actionCheck['programName'] = item.programName;
    actionCheck['sender'] = item.sender;
    actionCheck['receivedDate'] = item.receivedDate;
    actionCheck['scheduledDate'] = item.scheduledDate;
    actionCheck['message'] = item.message;
    actionCheck['recipient'] = item.recipient;
    actionCheck['eProductId'] = item.eProductId;
    actionCheck['award'] = item.award;

    actionRows.push(actionCheck);

    row[appConstants.OVERVIEW_RECEIVED_ID.DATE] = item['date'];
    row[appConstants.OVERVIEW_RECEIVED_ID.SENDER] = item.sender ? (item.sender.preferredName ? `${item.sender.preferredName} ${item.sender.lastName}` : `${item.sender.firstName} ${item.sender.lastName}`): '';
    row[appConstants.OVERVIEW_RECEIVED_ID.ACTIONS]= actions;

     
    if(item.eProductId){
      indexes.push(index);
      row[appConstants.OVERVIEW_RECEIVED_ID.DETAILS] = '';
      receivedRows.push(row);
    }else{
      let details = item.award ?  `${item.award.title} - ${item.programName}` : `${item.type} : ${item.programName}`;
      if(item.type === appConstants.REWARD){
        details = item.award ?  `${appConstants.REWARDTITLE} (${item.award.title}) - ${item.programName}` : `${appConstants.REWARDTITLE} : ${item.programName}`;
      }
      row[appConstants.OVERVIEW_RECEIVED_ID.DETAILS] =details;
      receivedRows.push(row);
    }
  });

  if(indexes.length > 0){
    dispatch(geteProductTitle(receivedData.collection, receivedRows, actionRows, receivedColumns, indexes, true));
    dispatch(ActionCreators.displayLoader(false));
  }
  else{
    const tableDataReceived = {columns: receivedColumns, rows: receivedRows, actions: actionRows};
    dispatch(ActionCreators.overviewHistoryReceived(tableDataReceived));
    dispatch(ActionCreators.isDisplayReceivedActions(false));
    dispatch(ActionCreators.displayLoader(false));
  }

};

export const sentJson = () => (dispatch, getState) => {
  const sentColumns = [appConstants.OVERVIEW_SENT_ID.DATE, 
    appConstants.OVERVIEW_SENT_ID.RECEIPIENT, 
    appConstants.OVERVIEW_SENT_ID.DETAILS, 
    appConstants.OVERVIEW_SENT_ID.SENDER, 
    appConstants.OVERVIEW_SENT_ID.STATUS, 
    appConstants.OVERVIEW_SENT_ID.ACTIONS];
  const sentRows = [];
  const actionRows = [];
  const indexes = [];
  const currentState = getState();
  dispatch(ActionCreators.displayLoader(true));
  const receivedUrl = CommonActions.getFullApiUrl(methodConstants.GET_SENT, currentState);
  const request = {
    'size': 4,
    'pages': '0',
    'nocache': Date.now().toString()
  };
  Http.get(receivedUrl, currentState, request).then((res) => {
    res.collection = CommonActions.sortDateByDesc(res.collection);
    res.collection.forEach ((item, index) => {
      const row = {};
      const actionCheck = {};
      const actions = [];
      if (item['type']==='ecard') {
        actions.push(appConstants.VIEW);
        actions.push(appConstants.RESEND);
        actionCheck['nomineeId'] = -1;
      }
      //For sent json doesn't have print certificate preview
      actionCheck['programId'] = item['programId'];
      actionCheck['id'] = item['id'];
      actionCheck['displayContainer'] = false;
      actionCheck['action'] = actions;
      actionCheck['detailsHref'] = item['detailsHref'];
      actionCheck['uniqueId'] = 1000 + index;

      //values for eCardactivity values:
      actionCheck['corporateValue'] = item.corporateValue;
      actionCheck['programName'] = item.programName;
      actionCheck['sender'] = item.sender;
      actionCheck['receivedDate'] = item.receivedDate;
      actionCheck['scheduledDate'] = item.scheduledDate;
      actionCheck['message'] = item.message;
      actionCheck['recipient'] = item.recipient;
      actionCheck['eProductId'] = item.eProductId;
      actionCheck['award'] = item.award;

      actionRows.push(actionCheck);

      row[appConstants.OVERVIEW_SENT_ID.DATE] = item['date'];
      row[appConstants.OVERVIEW_SENT_ID.STATUS] = item['status'];
      row[appConstants.OVERVIEW_SENT_ID.ACTIONS]= actions;
      row[appConstants.OVERVIEW_SENT_ID.RECEIPIENT] = item.recipient ? (item.recipient.preferredName ? `${item.recipient.preferredName} ${item.recipient.lastName}` :`${item.recipient.firstName} ${item.recipient.lastName}`) : '';
      row[appConstants.OVERVIEW_SENT_ID.SENDER] = item.sender ? (item.sender.preferredName ? `${item.sender.preferredName} ${item.sender.lastName}` : `${item.sender.firstName} ${item.sender.lastName}`) : '';

      if(item.eProductId){
        indexes.push(index);
        row[appConstants.OVERVIEW_SENT_ID.DETAILS] = '';
        sentRows.push(row);
      }else{
        let details = item.award ?  `${item.award.title} - ${item.programName}` : `${item.type} : ${item.programName}`;
        if(item.type === appConstants.REWARD){
          details = item.award ?  `${appConstants.REWARDTITLE} (${item.award.title}) - ${item.programName}` : `${appConstants.REWARDTITLE} : ${item.programName}`;
        }
        row[appConstants.OVERVIEW_SENT_ID.DETAILS] = details;
        sentRows.push(row);
      }
    });
    if(indexes.length > 0){
      dispatch(geteProductTitle(res.collection, sentRows, actionRows, sentColumns, indexes, false));
    }else{
      const tableDataSent = {columns: sentColumns, rows: sentRows, actions: actionRows};
      dispatch(ActionCreators.overviewHistorySent(tableDataSent));
      dispatch(ActionCreators.isDisplayReceivedActions(false));
      dispatch(ActionCreators.displayLoader(false));
    }

  })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
    });

};

export const bankSummaryJson = () => (dispatch, getState) => {
  const bankSummaryColumns = [appConstants.BANK_SUMMARY_ID.ACCOUNT_NAME,
    appConstants.BANK_SUMMARY_ID.DEPOSITS,
    appConstants.BANK_SUMMARY_ID.WITHDRAWALS,
    appConstants.BANK_SUMMARY_ID.BALANCE,
    appConstants.BANK_SUMMARY_ID.ACCESS_CODES,
    appConstants.BANK_SUMMARY_ID.ACTIONS];
  const bankSummaryRows = [];
  const currentState = getState();
  const bankUrl = CommonActions.getFullApiUrl(methodConstants.GET_BANK_OVERVIEW_INFO, currentState);
  dispatch(ActionCreators.displayLoader(true));
  dispatch(ActionCreators.isDisplayBanksSection(true));
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(bankUrl, currentState, request).then((res) => {
    res.collection.forEach((item) => {
      const row = {};
      row[appConstants.BANK_SUMMARY_ID.ACCOUNT_NAME] = item.bankName;
      row[appConstants.BANK_SUMMARY_ID.DEPOSITS] = 'N/A';
      row[appConstants.BANK_SUMMARY_ID.WITHDRAWALS] = 'N/A';
      row[appConstants.BANK_SUMMARY_ID.BALANCE] = 'N/A';
      row[appConstants.BANK_SUMMARY_ID.ACCESS_CODES] = 'N/A';
      if (item.bankType && item.bankType.toLowerCase() === appConstants.POINTS.toLowerCase()) {
        row[appConstants.BANK_SUMMARY_ID.DEPOSITS] = item.pointsDeposited;
        row[appConstants.BANK_SUMMARY_ID.WITHDRAWALS] = item.pointsWithdrawn;
        row[appConstants.BANK_SUMMARY_ID.BALANCE] = item.pointsBalance;
        row['points'] = CommonActions.numberWithCommas(item.pointsBalance);
        row['symbol'] = 'pts';
      } else if (item.bankType && item.bankType.toLowerCase() === appConstants.ACSCODES.toLowerCase()) {
        row[appConstants.BANK_SUMMARY_ID.ACCESS_CODES] = item.accessCodesBalance;
        row['points'] = CommonActions.numberWithCommas(item.accessCodesBalance);
        row['symbol'] = '';
      }
      row[appConstants.BANK_SUMMARY_ID.BANKID] = item.bankId;
      row[appConstants.BANK_SUMMARY_ID.ACTIONS] = 'View';
      bankSummaryRows.push(row);
    });
    const tableBankSummary = { columns: bankSummaryColumns, rows: bankSummaryRows };
    dispatch(ActionCreators.overviewBankSummary(tableBankSummary));
    dispatch(ActionCreators.displayLoader(false));
  })
    .catch((err) => {
      if(err.error && err.error.code === appConstants.NOT_ACCESSED_ERROR_CODE) {
        dispatch(ActionCreators.isDisplayBanksSection(false));
      }else{
        dispatch(ErrorActions.displayError(err));
      }
    });
};

export const recentOrdersJson = () => (dispatch, getState) => {
  const recentOrdersColumns = [appConstants.RECENT_ORDERS_ID.DATE,
    appConstants.RECENT_ORDERS_ID.ACTIVITY_TYPE,
    appConstants.RECENT_ORDERS_ID.ORDER_ID,
    appConstants.RECENT_ORDERS_ID.ORDER_DETAILS];
  const recentOrdersRows = [];

  const currentState = getState();
  const ordersUrl = CommonActions.getFullApiUrl(methodConstants.GET_ORDERS_OVERVIEW_INFO, currentState);
  dispatch(ActionCreators.displayLoader(true));
  dispatch(ActionCreators.isDisplayOrdersSection(true));
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(ordersUrl, currentState, request).then((res) => {
    res.collection.forEach((item) => {
      const row = {};
      row[appConstants.RECENT_ORDERS_ID.DATE] = item.activityDate;
      row[appConstants.RECENT_ORDERS_ID.ACTIVITY_TYPE] = item.description;
      row[appConstants.RECENT_ORDERS_ID.ORDER_ID] = item.sapOrderId;
      row[appConstants.RECENT_ORDERS_ID.P42ORDER_ID] = item.p42OrderId;
      row[appConstants.RECENT_ORDERS_ID.ORDER_DETAILS] = 'View';
      recentOrdersRows.push(row);
    });

    const tableRecentOrders = { columns: recentOrdersColumns, rows: recentOrdersRows };
    dispatch(ActionCreators.overviewRecentOrders(tableRecentOrders));
    dispatch(ActionCreators.displayLoader(false));
  })
    .catch((err) => {
      if(err.error && err.error.code === appConstants.NOT_ACCESSED_ERROR_CODE) {
        dispatch(ActionCreators.isDisplayOrdersSection(false));
      }else{
        dispatch(ErrorActions.displayError(err));
      }
    });

};

export const getProperties = () => (dispatch, getState) => {
  dispatch(ActionCreators.displayLoader(true));
  const currentState = getState();
  const customerId = currentState.customerId;
  if (customerId) {
    let propertiesUrl = CommonActions.getFullApiUrl(methodConstants.GET_PROPERTIES_URL, currentState);
    propertiesUrl = CommonActions.modifyString(propertiesUrl, '{:customerId}', customerId);
    const request = {
      'nocache': Date.now().toString()
    };
    Http.get(propertiesUrl, currentState, request).then((res) => {
      const resArr = res.filter(function (obj) {
        return obj.propertyCode === appConstants.PERMISSION.USER_STRENGTHS;
      });
      if (resArr && resArr[0] && resArr[0].propertyValue !== 'false' && resArr[0].propertyValue) {
        dispatch(getNewSkills());
      } else {
        dispatch(ActionCreators.isDisplaySkillsSection(false));
      }
      dispatch(ActionCreators.displayLoader(false));
      
    })
      .catch((err) => {
        dispatch(ErrorActions.displayError(err));
      });
  }
};

export const getNewSkills = () => (dispatch, getState) => {
  const currentState = getState();
  const { loaded = false } = currentState.overviewSkillsFinder;
  if (!loaded) {
    dispatch(ActionCreators.isDisplaySkillsSection(true));
    dispatch(ActionCreators.isDisplaySkillsLoader(true));
  }
  if (currentState.customerId && !loaded) {
    const objSkillsFinder = {
      loaded: true,
      data: []
    };
    dispatch(ActionCreators.overviewSkillsFinder(objSkillsFinder));
    let skillsUrl = CommonActions.getFullApiUrl(methodConstants.GET_SKILLS_NEW, currentState);
    skillsUrl = CommonActions.modifyString(skillsUrl, '{:customerId}', currentState.customerId);
    skillsUrl = CommonActions.modifyString(skillsUrl, '{:systemUserId}', CommonActions.getSystemUserId());
    const request = {
      'nocache': Date.now().toString()
    };
    Http.get(skillsUrl, currentState, request).then((res) => {
      if (Object.keys(res).length > 0) {
        objSkillsFinder.data =  Object.entries(res).sort(([, value1], [, value2]) => value2 - value1);
        dispatch(ActionCreators.isDisplaySkillsLoader(false));
        dispatch(ActionCreators.overviewSkillsFinder(objSkillsFinder));
      } else {
        dispatch(ActionCreators.isDisplaySkillsSection(false));
      }
    })
      .catch(() => {
        dispatch(ActionCreators.isDisplaySkillsLoader(false));
        dispatch(ActionCreators.isDisplaySkillsSection(false));
      });
  }
};


export const getAlerts = () => (dispatch, getState) => {
  dispatch(ActionCreators.displayLoader(true));
  const currentState = getState();
  const alertsUrl = CommonActions.getFullApiUrl(methodConstants.GET_ACCOUNT_ALERTS_URL, currentState);
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(alertsUrl, currentState, request).then((res) => {

    let flag = 0;

    const row = {};
    row.email = res.emailUpdate;
    row.password = res.passwordExpiry;
    row.additional = res.additionalInformation;
    row.points = res.pointsExpiry;
    row.accessCodes = res.accessCodesExpiry;
    if (res.emailUpdate.length > 0 || res.passwordExpiry.length > 0 || res.additionalInformation.length > 0 || res.passwordExpiry.length > 0 || res.accessCodesExpiry.length > 0) {
      flag = 1;
    }
    dispatch(ActionCreators.overviewAlerts(row));
    if (flag === 1)
      dispatch(ActionCreators.isDisplayAlertsSection(true));
    else
      dispatch(ActionCreators.isDisplayAlertsSection(false));

    CommonActions.scrollToTop();
    CommonActions.setFocusTrap();
    dispatch(ActionCreators.displayLoader(false));
  })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
      dispatch(ActionCreators.displayLoader(false));
    });

};


export const initializeOverview = (isTest) => (dispatch, getState) => {
  const currentState = getState();
  dispatch(ActionCreators.tabSelected(0));
  dispatch(receivedJson());
  dispatch(bankSummaryJson());
  dispatch(recentOrdersJson());
  dispatch(getProperties());
  dispatch(getAlerts());
  dispatch(ActionCreators.selectedDropDownValue('actions'));
  const pathName = appConstants.ROUTE_OVERVIEW;
  const url = CommonActions.getFullApiUrl(pathName, currentState);
  dispatch(CommonActions.route(url, isTest));
};

export const displayReceivedActions = (display, index) => (dispatch, getState) => {
  const historyReceived = getState().overviewHistoryReceived;
  historyReceived.actions[index].displayContainer = display;
  dispatch(ActionCreators.overviewHistoryReceived(historyReceived));
  dispatch(ActionCreators.isDisplayReceivedActions(display));
};

export const displayGivenActions = (display, index) => (dispatch, getState) => {
  const historySent = getState().overviewHistorySent;
  historySent.actions[index].displayContainer = display;
  dispatch(ActionCreators.overviewHistorySent(historySent));
  dispatch(ActionCreators.isDisplayReceivedActions(display));
  isActiveSegmentIndex = index;
};

export const getFacebookUrl = (programId) => (dispatch, getState) => {
  const currentState = getState();
  let facebookAPI = CommonActions.getFullApiUrl(methodConstants.GET_FACEBOOK_URL, currentState);
  facebookAPI = CommonActions.modifyString(facebookAPI, '{:programId}', programId);
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(facebookAPI, currentState, request).then((res) => {
    window.open(res.url);
  })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
    });

};

export const displayeCardActions = (display) => (dispatch) => {
  dispatch(ActionCreators.isDisplayeCardDialogActions(display));
  CommonActions.setBodyScroll(display);
  CommonActions.activateFocusTrap(display);
};

export const displayNominationActions = (display) => (dispatch) => {
  dispatch(ActionCreators.isDisplayNominationDialogActions(display));
  CommonActions.setBodyScroll(display);
  CommonActions.activateFocusTrap(display);
};

export const sendEcard = (type, tabSelected, recordId) => (dispatch, getState) => {
  const currentState = getState();
  let perfAPI = currentState.perfAPI+methodConstants.GET_USER_DETAILS;
  const customerDateFormat = getState().customerDateFormat;
  const data = {};
  let action = {};
  let actions = {};
  if(tabSelected === 0){
    const overviewHistoryReceived = currentState.overviewHistoryReceived;
    actions = overviewHistoryReceived.actions;
  }else{
    const overviewHistoryReceived = currentState.overviewHistorySent;
    actions = overviewHistoryReceived.actions;
  }

  if(actions){
    
    actions.forEach((item) => {
      if (type === appConstants.VIEW && recordId === item.id) {
        action = item;
      }
    });
    if (action) {
      data.activityType = 'eCards';
      data.recognition = action.corporateValue;
      data.program= action.programName;
      //data.from = action.sender.name;
      data.from = (action.sender.preferName ? action.sender.preferName : action.sender.firstName) + ' ' + action.sender.lastName;
      let receivedDate = action.receivedDate;
      if(!receivedDate){
        receivedDate = action.scheduledDate ? action.scheduledDate : action.date;
      }
      data.receivedOn = receivedDate ? CommonActions.getDateGenericFormat(receivedDate, customerDateFormat): '';
      data.message = action.message;
      data.to = action.recipient.name;
      data.eProductId = action.eProductId;
      data.id = recordId;
      data.senderId = action.sender.id;
      data.senderFullName = action.sender.fullName;
      //data.employeeId = action.sender.id;
      
      data.programId = action.programId;
      if(tabSelected !== 0){
        dispatch(ActionCreators.isDisplayRedeemLink(false));
        dispatch(ActionCreators.isDisplayReplyLink(false));
      }
      if (action.award) {
        if (action.award.title.includes('Points')) {
          data.awardLevel = action.award.title;
          data.awardValue = CommonActions.manipulateString(action.award.title);
          if(tabSelected === 0){
            dispatch(ActionCreators.isDisplayRedeemLink(true));
          }
          dispatch(ActionCreators.isDisplayAwardPoints(true));
        } else {
          dispatch(ActionCreators.isDisplayRedeemLink(false));
          dispatch(ActionCreators.isDisplayAwardPoints(false));
        }
      } else {
        dispatch(ActionCreators.isDisplayRedeemLink(false));
        dispatch(ActionCreators.isDisplayAwardPoints(false));
      }
      if(data.senderId && tabSelected === 0){
        perfAPI = CommonActions.modifyString(perfAPI, '{:userId}', data.senderId);
        dispatch(ActionCreators.displayLoader(true));
        const request = {
          'nocache': Date.now().toString()
        };
        Http.get(perfAPI, currentState, request).then((res) => {
          data.employeeId = res.employeeId;
          if (data.eProductId) {
            dispatch(geteProductUrl(data, tabSelected));
          }
          dispatch(ActionCreators.displayLoader(false));
        })
          .catch((err) => {
            dispatch(ErrorActions.displayError(err));
            dispatch(ActionCreators.displayLoader(false));
          });
      }else if (data.eProductId) {
        dispatch(geteProductUrl(data, tabSelected));
      }
    }
  }
};

export const getDialogAction = (eCardUrl, type, recordId) => (dispatch, getState) => {
  dispatch(ActionCreators.displayLoader(true));
  const currentState = getState();
  const tabSelected = currentState.tabSelected;
  const customerDateFormat = currentState.customerDateFormat;
  const trans = currentState.translationsGreatwork.customerLabels;
  const transvictories = currentState.translations;
  const eCardEventAPI = eCardUrl;
  const data = {};
  data.logoUrl = currentState.customerLogoUrl;
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(eCardEventAPI, currentState, request).then((res) => {
    if (type === appConstants.VIEW) {
      //customer specific labels
      data.corporateLabel = trans['corporate-value-label'];
      data.eCardLabel = trans['ecard-label'];
      data.awardLabel = trans['award-level-label'];

      //data.activityType = 'eCards';
      //data.activityType = trans['ecards'];
      data.activityType = trans['ecard-label'];
      data.recognition = res.corporateValue;
      data.program= res.programName;
      //data.from = res.sender.name;
      data.from = (res.sender.preferName ? res.sender.preferName : res.sender.firstName) + ' ' + res.sender.lastName;
      let receivedDate = res.receivedDate;
      if(!receivedDate){
        receivedDate = res.scheduledDate ? res.scheduledDate : res.date;
      }
      data.receivedOn = receivedDate ? CommonActions.getDateGenericFormat(receivedDate, customerDateFormat): '';
      data.message = res.message;
      data.to = res.recipient.name;
      data.eProductId = res.eProductId;
      data.id = recordId;
      data.senderId = res.sender.id;
      data.senderFullName = res.sender.fullName;
      data.employeeId = res.sender.employeeId;
      data.programId = res.programId;
      data.userUploadedImageId=res.userUploadedImageId;
      if(tabSelected !== 0){
        dispatch(ActionCreators.isDisplayRedeemLink(false));
        dispatch(ActionCreators.isDisplayReplyLink(false));
      }
      if (res.award) {
        if (res.award.title.includes('Points')) {
          data.awardLevel = res.award.title;
          data.awardValue = CommonActions.manipulateString(res.award.title);
          if(tabSelected === 0){
            dispatch(ActionCreators.isDisplayRedeemLink(true));
          }
          dispatch(ActionCreators.isDisplayAwardPoints(true));
        } else {
          dispatch(ActionCreators.isDisplayRedeemLink(false));
          dispatch(ActionCreators.isDisplayAwardPoints(false));
        }
      } else {
        dispatch(ActionCreators.isDisplayRedeemLink(false));
        dispatch(ActionCreators.isDisplayAwardPoints(false));
      }
      if (data.eProductId || data.userUploadedImageId) {
        dispatch(geteProductUrl(data, tabSelected));
      }
    } else if (type === appConstants.PRINT_CERTIFICATE_PREVIEW) {
      //customer specific labels
      data.descriptionAchievementLabel = trans['description-of-achievement-label'];
      data.corporateLabel = trans['corporate-value-label'];
      data.thankYouNoteLabel = trans['thank-you-note-label'];
      data.awardLabel = trans['award-level-label'];
      data.nominationLabel = `${trans['nomination-label']} ${trans['submitted']} ${CommonActions.isDefined(transvictories['on']) ? transvictories['on']: 'On'}`;
      
      data.awardLevel = res.award.title;
      data.date = CommonActions.getDateGenericFormat(res.date, customerDateFormat);
      data.submittedBy= res.sender.name;
      data.nominee = res.recipient.name;
      data.description = res.achievementDescription;
      data.nomineeId = res.copiedFromId;
      data.value = res.corporateValue;
      data.thankYouNote = res.thankYouNote;
      dispatch(ActionCreators.nominationActivityValues(data));
      dispatch(displayNominationActions(true));
      dispatch(ActionCreators.displayLoader(false));
    }

  })
    .catch((err) => {
      dispatch(ActionCreators.displayLoader(false));
      if(err.error.code === appConstants.SERVER_TOKEN_ERROR_CODE){
        dispatch(sendEcard(type, tabSelected, recordId));
      }else{
        dispatch(ErrorActions.displayError(err));
      }
    });

};

export const getCatalog = (programId, catalogLink) => (dispatch, getState) => {
  if(catalogLink){
    window.open(catalogLink);
  }else{
    const currentState = getState();
    let catalogAPI = CommonActions.getFullApiUrl(methodConstants.GET_CATALOG_API, currentState);
    catalogAPI = catalogAPI + '?programId=' + programId;
    window.open(catalogAPI);
  }
  
};

export const resendEcard = (recordId) => (dispatch, getState) => {
  const currentState = getState();
  let resendAPI = CommonActions.getFullApiUrl(methodConstants.RESEND_ECARD, currentState);
  resendAPI += recordId;
  Http.post(resendAPI, currentState, {}).then((res) => {
    dispatch(ActionCreators.displayLoader(false));
    if (res) {
      dispatch(ActionCreators.infoMessage(CommonActions.infoMessage('Your eCard has been successfully resent', true)));
      dispatch(ActionCreators.displayMessage(true));
      dispatch(displayGivenActions(false, isActiveSegmentIndex));
    }
  })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
    });

};

export const displayHistoryActions = (action, programId, eCardUrl, recordId, catalogLink, nomineeId) => (dispatch) => {
  dispatch(ActionCreators.displayLoader(true));
  switch (action) {
    case appConstants.SHARE_ON_FACEBOOK:
      dispatch(getFacebookUrl(programId));
      dispatch(ActionCreators.displayLoader(false));
      break;
    case appConstants.CATALOG:
      dispatch(getCatalog(programId, catalogLink));
      dispatch(ActionCreators.displayLoader(false));
      break;
    case appConstants.VIEW:
      if(nomineeId === -1){
        dispatch(getDialogAction(eCardUrl, appConstants.VIEW, recordId));
        dispatch(ActionCreators.displayLoader(false));
      }else{
        dispatch(getViewCertificate(nomineeId));
        dispatch(ActionCreators.displayLoader(false));
      }
      break;
    case appConstants.PRINT_CERTIFICATE_PREVIEW:
      dispatch(getDialogAction(eCardUrl, appConstants.PRINT_CERTIFICATE_PREVIEW));
      break;
    case appConstants.RESEND:
      dispatch(resendEcard(recordId));
      break;
    case appConstants.PRINT_CERTIFICATE_TRANS:
      dispatch(getCertificate(nomineeId));
      break;
  }

};

export const getContactUsAction = (code) => (dispatch, getState) => {
  if (CommonActions.isSatisfied(code)) {
    const currentState = getState();
    const contactUsURL = CommonActions.getFullApiUrl(appConstants.ROUTE_CONTACT_US, currentState);
    window.open(contactUsURL, '_blank');
  }
};

export const linkDetailsActions = (pathName, isTest) => (dispatch, getState) => {
  if (pathName === appConstants.ROUTE_BANK_ACCOUNT
    || pathName === appConstants.ROUTE_ORDERS
    || pathName === appConstants.ROUTE_HISTORY_RECEIVED
    || pathName === appConstants.ROUTE_HISTORY_SENT) {
    const currentState = getState();
    const detailsAPI = CommonActions.getFullApiUrl(pathName, currentState);
    if(pathName === appConstants.ROUTE_HISTORY_RECEIVED
      || pathName === appConstants.ROUTE_HISTORY_SENT) {
      window.open(detailsAPI, '_self');
    }else{
      CommonActions.scrollToTop();
      CommonActions.setFocusTrap();
      dispatch(CommonActions.route(detailsAPI, isTest));
    }
  }
};

export const linkDetailActionColumn = (orderId, sapOrderId, link, bankId, bankName, isTest) => (dispatch, getState) => {
  if (link === appConstants.ROUTE_ORDERS)
    dispatch(OrderActions.getOrderDetails(sapOrderId, isTest));
  else if (link === appConstants.ROUTE_BANK_ACCOUNT) {
    dispatch(ActionCreators.bankNameSelected(bankName));
    dispatch(ActionCreators.activeBankId(bankId));
    dispatch(ActionCreators.isBankViewClicked(true));
    dispatch(BankActions.setActiveTab(-1, bankName, bankId));
    const currentState = getState();
    const viewAPI = CommonActions.getFullApiUrl(link, currentState);
    dispatch(CommonActions.route(viewAPI, isTest));
  }
};

export const getCertificate = (nomineeId) => (dispatch, getState) => {
  const isDialog = true;
  const currentState = getState();
  dispatch(ActionCreators.displayLoader(true));
  let certificateAPI = CommonActions.getFullApiUrl(methodConstants.GET_PRESENTATION_CERTIFICATE, currentState);
  certificateAPI = CommonActions.modifyString(certificateAPI, '{:nominationNomineeId}', nomineeId);
  const type = 'pdf';
  const params = {
    'download': type,
    'nocache': Date.now().toString()
  };
  Http.get(certificateAPI, currentState, params).then((res) => {
    CommonActions.getFileOpenFromByteArray(res, CommonActions.getExtension(type));
    dispatch(ActionCreators.displayLoader(false));
  })
    .catch((err) => {
      const errRes = CommonActions.arrayBufferToString(err);
      dispatch(ErrorActions.displayError(errRes, isDialog));
      dispatch(ActionCreators.displayLoader(false));
    });
};


export const getViewCertificate = (nomineeId) => (dispatch, getState) => {
  const currentState = getState();
  dispatch(ActionCreators.displayLoader(true));
  let certificateAPI = CommonActions.getFullApiUrl(methodConstants.GET_NOMINATION_PDF, currentState);
  certificateAPI = CommonActions.modifyString(certificateAPI, '{:nominationNomineeId}', nomineeId);
  window.open(certificateAPI);
  dispatch(ActionCreators.displayLoader(false));
};

export const geteCardPrint = (eProductId) => (dispatch, getState) => {
  const isDialog = true;
  const currentState = getState();
  dispatch(ActionCreators.displayLoader(true));
  let certificateAPI = CommonActions.getFullApiUrl(methodConstants.GET_ECARD_PRINT, currentState);
  certificateAPI = CommonActions.modifyString(certificateAPI, '{:eProductId}', eProductId);
  const type = 'pdf';
  const params = {
    'download': type,
    'nocache': Date.now().toString()
  };
  Http.get(certificateAPI, currentState, params).then((res) => {
    CommonActions.getFileOpenFromByteArray(res, CommonActions.getExtension(type));
    dispatch(ActionCreators.displayLoader(false));
  })
    .catch((err) => {
      const errRes = CommonActions.arrayBufferToString(err);
      dispatch(ErrorActions.displayError(errRes, isDialog));
    });
};

export const geteProductUrl = (data, tabSelected) => (dispatch, getState) => {
  const currentState = getState();
  dispatch(ActionCreators.displayLoader(true));
  if (data.userUploadedImageId) {
    let imageAPI = CommonActions.getFullApiUrl(methodConstants.GET_ECARD_IMAGE, currentState);
    imageAPI = CommonActions.modifyString(imageAPI, '{:userUploadedImageId}', data.userUploadedImageId);
    const request = {
      'nocache': Date.now().toString()
    };
    Http.get(imageAPI, currentState, request).then((res) => {
      data.url = res.urls.largeUrl ? res.urls.largeUrl : res.urls.thumbNailUrl;
      data.videoUrl = '';
      if (tabSelected === 0) {
        dispatch(getEmailAddressForUserId(data));
        dispatch(ActionCreators.isDisplayReplyLink(true));
      } else {
        dispatch(ActionCreators.ecardActivityValues(data));
        dispatch(displayeCardActions(true));
        dispatch(ActionCreators.displayLoader(false));
      }
    })
      .catch((err) => {
        dispatch(ErrorActions.displayError(err));
      });
  } else if (data.eProductId) {
    let eProductAPI = CommonActions.getFullApiUrl(methodConstants.GET_EPRODUCT_URL, currentState);
    eProductAPI = CommonActions.modifyString(eProductAPI, '{:eProductId}', data.eProductId);
    const request = {
      'nocache': Date.now().toString()
    };
    Http.get(eProductAPI, currentState, request).then((res) => {
      data.url = res.largeUrl ? res.largeUrl : res.thumbNailUrl;
      data.videoUrl = res.videoUrl;
      if (tabSelected === 0) {
        dispatch(getEmailAddressForUserId(data));
        dispatch(ActionCreators.isDisplayReplyLink(true));
      } else {
        dispatch(ActionCreators.ecardActivityValues(data));
        dispatch(displayeCardActions(true));
        dispatch(ActionCreators.displayLoader(false));
      }
    })
      .catch((err) => {
        dispatch(ErrorActions.displayError(err));
      });
  }
};

export const getAlertAction = (endPoint) => (dispatch, getState) => {
  const currentState = getState();
  const api = CommonActions.getFullApiUrl(endPoint, currentState);
  window.open(api);
};

export const getEmailAddressForUserId = (data) => (dispatch, getState) => {
  const currentState = getState();
  dispatch(ActionCreators.displayLoader(true));
  let userSearchAPI = CommonActions.getFullApiUrl(methodConstants.SEARCH_USER, currentState);
  userSearchAPI = CommonActions.modifyString(userSearchAPI, '{:employeeId}', data.employeeId);
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(userSearchAPI, currentState, request).then((res) => {
    res.forEach((result) => {
      if(result.systemUserId === data.senderId){ // && result.fullName === data.employeeId){
        data.senderEmailAddress = result.emailAddress;
      }
    });
    dispatch(ActionCreators.ecardActivityValues(data));
    dispatch(displayeCardActions(true));
    dispatch(ActionCreators.displayLoader(false));
  })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
    });
};
